import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { LorenAuthenticationService } from "../loren-authentication-service/loren-authentication.service";
import { LorenFeature } from "../../enums/loren-feature.enum";

@Injectable({
  providedIn: "root",
})
export class LorenFeatureToggleService {
  private authenticationService = inject(LorenAuthenticationService);


  userHasOneOfFeatures(features: LorenFeature[]): Observable<boolean> {
    return this.authenticationService.getUserFeatures().pipe(
      take(1),
      map((x) => {
        return x.some((f) =>
          features.reduce((acc, feature) => f === feature || acc, false)
        );
      })
    );
  }

  userHasFeature(feature: LorenFeature): Observable<boolean> {
    return this.authenticationService.getUserFeatures().pipe(
      take(1),
      map((x) => {
        return x.some((f) => f === feature);
      })
    );
  }

  executeIfUserHasFeature(feature: LorenFeature, callback: () => void): void {
    this.userHasFeature(feature)
      .pipe(take(1))
      .subscribe((x) => {
        if (x) {
          callback();
        }
      });
  }
}
